class PageVideo {
    constructor() {
        this.page_video = document.querySelectorAll('.page-video');
        this.screen_video = [];
        this.current_play_video_index = -1;
        this.initVideo();
        this.initClick();
        
    }
    initClick() {
        const page_voice = document.querySelector('.voice_play_all');
        if (!page_voice) return;
        page_voice.addEventListener('click', () => {
            const voice_play_voice = page_voice.querySelector('.voice_play_voice');
            const voice_play_muted = page_voice.querySelector('.voice_play_muted');
            const current_voice = voice_play_voice.classList.contains('hide');
            const current_muted = voice_play_muted.classList.contains('hide');
            let muted = true;
            if (current_voice) {
                voice_play_voice.classList.remove('hide');
                voice_play_muted.classList.add('hide');
                muted = false;
                // console.log('open', muted);
            }
            if (current_muted) {
                voice_play_voice.classList.add('hide');
                voice_play_muted.classList.remove('hide');
                muted = true;
                // console.log('close', muted);
            }
            for (const video of this.page_video) {
                video.muted = muted;
            }
        });
    };

    play_next_video(video) {
        const video_index = video.video_index;
        const index = video_index * 1 + 1;
        this.screen_video[index] && this.screen_video[index].play();
    };
    videoEventAll(video) {
        const previousElementSibling = video.previousElementSibling;
        const nextElementSibling = video.nextElementSibling;
        const playIcon = nextElementSibling.querySelector('.v-play');
        const pauseIcon = nextElementSibling.querySelector('.v-pause');
        video.addEventListener('play', () => {
            this.current_play_video_index = video.video_index;
            playIcon.classList.remove('hide');
            pauseIcon.classList.add('hide');
        });
        video.addEventListener('canplay', function(e) {
            // console.log('canplay');
            previousElementSibling.classList.contains('video-mask') && previousElementSibling.classList.add('hide');
        });
        video.addEventListener('ended', () => {
            this.play_next_video(video);
            playIcon.classList.add('hide');
            pauseIcon.classList.remove('hide');
        });
        video.addEventListener('pause', () => {
            playIcon.classList.add('hide');
            pauseIcon.classList.remove('hide');
        });
        playIcon.addEventListener('click', () => {
            // console.log('pause');
            video.pause();
        })
        pauseIcon.addEventListener('click', () => {
            for (const video of this.page_video) {
                video.pause();
            }
            video.play();
        })
    };
    playVideo() {
        const screen_video = [...this.screen_video].filter((item) => item);
        const first_video = screen_video[0];
        const last_video = screen_video[screen_video.length - 1];
        let play_video = first_video;
        for (const video of this.page_video) {
            // 当前播放的视频不是可视区域第一个视频
            if (!video.paused) { this.current_play_video_index  = video.video_index; }
            video.currentTime = 0;
            video.loop = false;
            video.pause();
        }
        last_video && (last_video.loop = true);
        if (this.current_play_video_index != -1 && screen_video[this.current_play_video_index]) {
            play_video = screen_video[this.current_play_video_index];
        }
        play_video && play_video.play();
    };
    observeVideo(entries) {
        for(const entry of entries) {
            const { target, target: { video_index } } = entry;
            this.screen_video[video_index] = entry.isIntersecting ? target : null;
        }
        this.playVideo();
    };
    initVideo() {
        const io = new IntersectionObserver((entries) => this.observeVideo(entries), { threshold: [0.5], delay: 100 });
        for (let i = 0; i < this.page_video.length; i++) {
            const video = this.page_video[i];
            video.video_index = i;
            io.observe(video);
            this.videoEventAll(video);
        }
    }
}
new PageVideo();